import React from "react";
import Image from "next/image";
import { IMAGE_SIZES } from "@/lib/imageSizes";

type Props = {
  src: string;
  width: number;
  height: number;
  alt: string;
  reference?: string;
};

const ImageMDX: React.FC<Props> = ({ src, width, height, alt, reference }) => {
  return (
    <div className="flex w-full items-center justify-center">
      <Image
        src={src}
        width={width}
        height={height}
        alt={alt}
        sizes={IMAGE_SIZES.full}
      />
      {reference && <p className="sr-only">Reference: {reference} </p>}
    </div>
  );
};

export default ImageMDX;
